import { SelectProps } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CALENDAR_EVENTS_DATE_RANGE_FILTERS } from '../../../../sic-lib/defaults';
import { CalendarEventsFilterRanges } from '../../../../sic-lib/enums/CalendarEventsFilterRanges';

const useStyles = makeStyles()((theme: Theme) => ({
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

type Props = SelectProps & {
    onSelectHandler: React.Dispatch<{
        rangeFilter: CalendarEventsFilterRanges;
    }>;
    className: string;
};

export default function SelectDateRangeFilter({ onSelectHandler, className, ...props }: Props) {
    const { classes } = useStyles();

    const selectOptions = CALENDAR_EVENTS_DATE_RANGE_FILTERS;

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelectHandler({
            rangeFilter: +event.target.value as CalendarEventsFilterRanges,
        });
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            className={className}
            id={props.id || 'select_calendar_date_ranges_list'}
            label={props.label || 'Filter by Date'}
            onChange={handleSelect}
        >
            {selectOptions.map(filterItem => (
                <MenuItem
                    className={classes.menuItem}
                    key={filterItem.value}
                    value={filterItem.value}
                >
                    {filterItem.label}
                </MenuItem>
            ))}
        </TextField>
    );
}
